import { render, staticRenderFns } from "./PrizesDetail.vue?vue&type=template&id=a85fc512&scoped=true"
import script from "./PrizesDetail.vue?vue&type=script&lang=ts"
export * from "./PrizesDetail.vue?vue&type=script&lang=ts"
import style0 from "./PrizesDetail.vue?vue&type=style&index=0&id=a85fc512&lang=scss"
import style1 from "./PrizesDetail.vue?vue&type=style&index=1&id=a85fc512&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85fc512",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\sandy\\Desktop\\EIOSYS\\Admin\\Alembic-Grow-Admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a85fc512')) {
      api.createRecord('a85fc512', component.options)
    } else {
      api.reload('a85fc512', component.options)
    }
    module.hot.accept("./PrizesDetail.vue?vue&type=template&id=a85fc512&scoped=true", function () {
      api.rerender('a85fc512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prizes/components/PrizesDetail.vue"
export default component.exports